var render = function render(){var _vm=this,_c=_vm._self._c;return _c('partProgress',{attrs:{"title":"部件主页"}})
}
var staticRenderFns = []

export { render, staticRenderFns }